export const PartialExit = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none"><path stroke="#1470CC" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13 12v16M17 19.999h10M24.14 17l2.858 3-2.857 3" /></svg>
    )
}